import classNames from 'classnames';
import React, { ReactNode } from 'react';
import styles from './TableButton.module.css';

enum Color {
  Primary = 'primary',
  Destructive = 'destructive',
}

const TableButton = ({
  className,
  color = Color.Primary,
  icon,
  children,
  ...props
}: JSX.IntrinsicElements['button'] & {
  buttonType?: 'button' | 'link';
  color?: Color;
  icon?: ReactNode;
}) => {
  return (
    <button
      {...props}
      className={classNames(
        'font-body-MdSemibold',
        styles.container,
        styles[color],
        className,
      )}
    >
      {icon}
      {children}
    </button>
  );
};

export default Object.assign(TableButton, { Color });
